export default {
  total(amount, taxes) {
    let total = 0
    for(let tax in taxes) {
      tax = taxes[tax]
      if (tax.rate !== undefined) {
        tax.rate = tax.rate.toString().replace(',', '.')
        if (tax.rate > 1) {
          tax.rate = tax.rate / 100
        }
        total += (amount * parseFloat(tax.rate))
      }
    }
    return parseFloat(amount) + parseFloat(total)
  }
}
